import React, { useState, useEffect } from "react";
import "./style.scss";
//nav bar
import Navbar from "../../../components/navbar/navbar";
import PageHeader from "../../../components/pageComponents/header";
import ThreeColText from "../../../components/pageComponents/threeColText";
// utile
import { debounce } from "../../../utils/debounce";
import { useTranslation } from "react-i18next";

const CholesterolPage = () => {
  const { t } = useTranslation();
  const [isMobile, setMobile] = useState(
    window.innerWidth <= 600 || window.innerHeight <= 650
  );

  const debouncedHandleResize = debounce(function handleResize() {
    setMobile(window.innerWidth <= 600 || window.innerHeight <= 650);
  }, 300);

  useEffect(() => {
    window.addEventListener("resize", debouncedHandleResize);

    return (_) => {
      window.removeEventListener("resize", debouncedHandleResize);
    };
  });

  return (
    <div className="App">
      {!isMobile && <Navbar />}
      <div className={isMobile ? "page__mobile" : "page"}>
        <div className="App-header">
          <PageHeader
            title1={t("ange_demon_title1")}
            title2={t("ange_demon_title2")}
            subtitle={t("ange_demon_subtitle")}
            color="#ff3300"
            bgImg={require("../../../images/pages/MytheRite.jpg")}
            isMobile={isMobile}
          >
            <div className="page__content">{t("ange_demon_text_intro_1")}</div>
            <div className="page__content">{t("ange_demon_text_intro_2")}</div>
            <div className="page__content">{t("ange_demon_text_intro_3")}</div>
            <div className="page__content">{t("ange_demon_text_intro_4")}</div>
            <div className="page__content">{t("ange_demon_text_intro_5")}</div>
            <div className="page__content">{t("ange_demon_text_intro_6")}</div>
          </PageHeader>
        </div>
        <ThreeColText
          col1Txt={[t("ange_demon_text_core_1a")]}
          col2Txt={[t("ange_demon_text_core_2a"),t("ange_demon_text_core_2b"), t('ange_demon_text_core_2c')]}
          col3Txt={[t("ange_demon_text_core_3a"),t("ange_demon_text_core_3b")]}
          col1Title={[
            t("mythe_text_title_1a"),
            t("mythe_text_title_1b"),
            t("mythe_text_title_1c"),
          ]}
          col2Title={[
            t("mythe_text_title_2a"),
            t("mythe_text_title_2b"),
            t("mythe_text_title_2c"),
          ]}
          col3Title={[
            t("mythe_text_title_3a"),
            t("mythe_text_title_3b"),
            t("mythe_text_title_3c"),
          ]}
          color="#ff3300"
        />
      </div>
    </div>
  );
};

export default CholesterolPage;
